import { Component, OnInit, Input, ElementRef, OnChanges, OnDestroy, HostListener } from '@angular/core';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-form-info-card',
  templateUrl: './turns-form-info-card.component.html',
  styleUrls: ['./turns-form-info-card.component.scss']
})
export class TurnsFormInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormBasic;
  sessionContextList;
  centerList;
  editingLocked;
  updateFormInfoSubscription: Subscription;

  basicDataForm = new FormGroup({
    active: new FormControl({value: null, disabled: true}),
    name: new FormControl({ value: null, disabled: true}, Validators.required),
    selectedCenter: new FormControl({value: null, disabled: true }, Validators.required),
    selectedSessionContext: new FormControl({value: null, disabled: true }, Validators.required)
  });
  getFormSessionContextsSubscription: Subscription;
  updateFormDesksSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
    private formsTurnsService: FormsTurnsService,
    private snackbarService: SnackBarService,
    private eRef: ElementRef) {
      this.editingLocked = true;
    }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.basicDataForm.patchValue({
      selectedCenter: this.getSelectedCenterInternalId()
    });
  }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.form && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public deskSelectedChanged(event) {
    this.basicDataForm.patchValue({
      selectedSessionContext: null

    });
    this.getFormSessionContexts(this.getSelectedCenterInternalId());
  }

  public submitForm() {
    if (this.form.CenterInternalId !== this.basicDataForm.get('selectedCenter').value.InternalId) {
      this.clearAssignedDesks();
    }
    this.updateFormInfoSubscription = this.formsTurnsService.updateFormInfo(this.form.InternalId, this.basicDataForm.get('active').value, this.basicDataForm.get('name').value, this.getSelectedCenterInternalId(), this.getSelectedSessionContextInternalId()).subscribe(
      (res) => {
        this.lockEdition();
        this.snackbarService.open('broadcastings-page.snackbar messages.update broadcasting success', 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getFormSessionContexts(centerInternalId) {
    this.getFormSessionContextsSubscription = this.formsTurnsService.getFormSessionContexts(centerInternalId).subscribe(
      (res) => {
        this.sessionContextList = res;
        this.basicDataForm.patchValue({
          selectedSessionContext: this.setSelectedSessionContext()
        });
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getSelectedCenterInternalId() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public getSelectedSessionContextInternalId() {
    if (this.sessionContextList && this.sessionContextList.length === 1) {
      return this.sessionContextList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedSessionContext').value) {
        return this.basicDataForm.get('selectedSessionContext').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public clearAssignedDesks() {
    this.updateFormDesksSubscription = this.formsTurnsService.updateFormDesks(this.form.InternalId, this.form.Active, []).subscribe(
      (res) => {
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.formsTurnsService.refreshForm();
      }
    );
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'turns-page.snackbar messages.name form error';
    } else if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'turns-page.snackbar messages.selected center form error';
    } else if (!this.basicDataForm.get('selectedSessionContext').valid) {
      return 'turns-page.snackbar messages.selected session context form error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.form.Active,
      name: this.form.TurnFormName,
      selectedCenter: this.setSelectedCenter(),
      selectedSessionContext: this.setSelectedSessionContext()
    });
    this.getFormSessionContexts(this.form.CenterInternalId);
  }

  public unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('selectedCenter').enable();
    this.basicDataForm.get('selectedSessionContext').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('selectedCenter').disable();
    this.basicDataForm.get('selectedSessionContext').disable();
    this.editingLocked = true;
  }

  public setSelectedCenter() {
    if (this.form) {
      for (const center of this.centerList) {
        if (center.InternalId === this.form.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedSessionContext() {
    if (this.form && this.sessionContextList) {
      for (const sesesionContext of this.sessionContextList) {
        if (sesesionContext.InternalId === this.form.MsessionInternalId) {
          return sesesionContext;
        }
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.updateFormInfoSubscription) { this.updateFormInfoSubscription.unsubscribe(); }
    if (this.getFormSessionContextsSubscription) { this.getFormSessionContextsSubscription.unsubscribe(); }
    if (this.updateFormDesksSubscription) { this.updateFormDesksSubscription.unsubscribe(); }
  }
}
